// import React from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { getHomeBannerDetailList } from "../../store/Slice/homeBannerDetailSlice";
// import { useNavigate } from "react-router-dom";

// const HomeBanner = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const { homeBannerDetailData, loading } = useSelector(
//     (state) => state.homeBannerDetailList
//   );

//   const [imageLoaded, setImageLoaded] = React.useState(false);

//   // Fetch banner data once
//   React.useEffect(() => {
//     if (!homeBannerDetailData) {
//       dispatch(getHomeBannerDetailList());
//     }
//   }, [dispatch, homeBannerDetailData]);

//   const banners = React.useMemo(() => {
//     if (
//       homeBannerDetailData?.code === 200 &&
//       homeBannerDetailData?.data?.length
//     ) {
//       return homeBannerDetailData.data;
//     }
//     return [];
//   }, [homeBannerDetailData]);

//   const banner = banners[0];

//   // Preload API image and wait for it
//   React.useEffect(() => {
//     if (banner?.vWebpImage) {
//       const img = new Image();
//       img.src = banner.vWebpImage;
//       img.onload = () => setImageLoaded(true);
//     }
//   }, [banner]);

//   const handleBookNowClick = () => navigate("/book-now");

//   // Don't render section until image is loaded
//   if (!banner || loading || !imageLoaded) {
//     return (
//       <section
//         className="ptb-100 home-bannersection"
//         style={{
//           minHeight: "576px",
//           backgroundColor: "#f6f6f6",
//         }}
//       />
//     );
//   }

//   const [firstTwoWords, ...rest] = banner?.vSubHeading?.split(" ") || [];

//   return (
//     <>
//       {/* Preload real banner image */}
//       <link rel="preload" as="image" href={banner?.vWebpImage} />

//       <section
//         className="ptb-100 home-bannersection"
//         style={{
//           backgroundImage: `url(${banner?.vWebpImage})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//         }}
//       >
//         {/* Hidden image to prioritize LCP */}
//         <img
//           src={banner?.vWebpImage}
//           alt="MopForce Banner"
//           fetchPriority="high"
//           style={{ width: 0, height: 0, opacity: 0 }}
//         />

//         <div className="container">
//           <div className="row align-items-center">
//             <div className="col-lg-7 col-md-12">
//               <div className="banner-content">
//                 {banner?.vHeading && (
//                   <span className="small-title">{banner.vHeading}</span>
//                 )}

//                 {banner?.vSubHeading && (
//                   <h1 className="banner-title">
//                     <span>
//                       {[firstTwoWords, rest[0]].filter(Boolean).join(" ")}
//                     </span>{" "}
//                     {rest.slice(1).join(" ")}
//                   </h1>
//                 )}

//                 {banner?.tDescription && <p>{banner.tDescription}</p>}

//                 <button
//                   className="success-orangebtn"
//                   type="button"
//                   onClick={handleBookNowClick}
//                 >
//                   Book Now
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default HomeBanner;

// import React from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { getHomeBannerDetailList } from "../../store/Slice/homeBannerDetailSlice";
// import { useNavigate } from "react-router-dom";

// const HomeBanner = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const { homeBannerDetailData, loading } = useSelector(
//     (state) => state.homeBannerDetailList
//   );

//   React.useEffect(() => {
//     if (!homeBannerDetailData) {
//       dispatch(getHomeBannerDetailList());
//     }
//   }, [dispatch, homeBannerDetailData]);

//   const banners = React.useMemo(() => {
//     if (
//       homeBannerDetailData?.code === 200 &&
//       homeBannerDetailData?.data?.length
//     ) {
//       return homeBannerDetailData.data;
//     }
//     return [];
//   }, [homeBannerDetailData]);

//   const banner = banners[0];

//   const handleBookNowClick = () => navigate("/book-now");

//   if (!banner || loading) {
//     return (
//       <section
//         className="ptb-100 home-bannersection"
//         style={{
//           minHeight: "576px",
//           backgroundColor: "#f6f6f6",
//         }}
//       />
//     );
//   }

//   const [firstTwoWords, ...rest] = banner?.vSubHeading?.split(" ") || [];

//   return (
//     <>
//       {/* Preload banner image */}
//       <link rel="preload" as="image" href={banner?.vWebpImage} />

//       <section
//         className="ptb-100 home-bannersection"
//         style={{
//           backgroundImage: `url(${banner?.vWebpImage})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           backgroundRepeat: "no-repeat",
//         }}
//       >
//         {/* LCP-targeted image */}
//         <img
//           src={banner?.vWebpImage}
//           alt="MopForce Banner"
//           fetchPriority="high"
//           decoding="async"
//           loading="eager"
//           style={{
//             width: "100%",
//             height: "auto",
//             display: "block",
//             position: "absolute",
//             top: 0,
//             left: 0,
//             zIndex: -1,
//             opacity: 0,
//             pointerEvents: "none",
//           }}
//         />

//         <div className="container">
//           <div className="row align-items-center">
//             <div className="col-lg-7 col-md-12">
//               <div className="banner-content">
//                 {banner?.vHeading && (
//                   <span className="small-title">{banner.vHeading}</span>
//                 )}

//                 {banner?.vSubHeading && (
//                   <h1 className="banner-title">
//                     <span>
//                       {[firstTwoWords, rest[0]].filter(Boolean).join(" ")}
//                     </span>{" "}
//                     {rest.slice(1).join(" ")}
//                   </h1>
//                 )}

//                 {banner?.tDescription && <p>{banner.tDescription}</p>}

//                 <button
//                   className="success-orangebtn"
//                   type="button"
//                   onClick={handleBookNowClick}
//                 >
//                   Book Now
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default HomeBanner;

// import React from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { getHomeBannerDetailList } from "../../store/Slice/homeBannerDetailSlice";
// import { useNavigate } from "react-router-dom";

// // Dynamically handle loading the image with preload
// const HomeBanner = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const { homeBannerDetailData, loading } = useSelector(
//     (state) => state.homeBannerDetailList
//   );

//   const [imageSrc, setImageSrc] = React.useState(null);  // Start with null for lazy load
//   const [isImageLoaded, setIsImageLoaded] = React.useState(false);  // Track image load state

//   React.useEffect(() => {
//     if (!homeBannerDetailData) {
//       dispatch(getHomeBannerDetailList());
//     }
//   }, [dispatch, homeBannerDetailData]);

//   const banners = React.useMemo(() => {
//     if (homeBannerDetailData?.code === 200 && homeBannerDetailData?.data?.length) {
//       return homeBannerDetailData.data;
//     }
//     return [];
//   }, [homeBannerDetailData]);

//   const banner = banners[0];

//   const handleBookNowClick = () => navigate("/book-now");

//   // Preload the full image URL dynamically
//   React.useEffect(() => {
//     if (banner?.vWebpImage) {
//       // Preload the high-res image
//       const preloadLink = document.createElement("link");
//       preloadLink.rel = "preload";
//       preloadLink.as = "image";
//       preloadLink.href = banner.vWebpImage;
//       preloadLink.fetchPriority = "high";
//       document.head.appendChild(preloadLink);

//       // Set the real banner image source after preload
//       setImageSrc(banner.vWebpImage);

//       // Clean up preload link on unmount
//       return () => {
//         document.head.removeChild(preloadLink);
//       };
//     }
//   }, [banner]);

//   // Show loading skeleton or empty until data is ready
//   if (!banner || loading) {
//     return (
//       <section className="ptb-100 home-bannersection" style={{ minHeight: "576px", backgroundColor: "#f6f6f6" }} />
//     );
//   }

//   // Split subheading for better rendering
//   const [firstTwoWords, ...rest] = banner?.vSubHeading?.split(" ") || [];

//   return (
//     <section className="ptb-100 home-bannersection" style={{ position: "relative", overflow: "hidden" }}>
//       {/* Preload banner image */}
//       <link rel="preload" as="image" href={banner?.vWebpImage} fetchPriority="high" />

//       {/* Dynamically load banner image with async image handling */}
//       {imageSrc && (
//         <img
//           src={imageSrc}
//           alt="MopForce Banner"
//           fetchPriority="high"
//           decoding="async"
//           loading="eager"
//           onLoad={() => setIsImageLoaded(true)} // Image loaded callback
//           style={{
//             width: "100%",
//             height: "100%",
//             objectFit: "cover",
//             position: "absolute",
//             top: 0,
//             left: 0,
//             zIndex: -1,
//             filter: isImageLoaded ? "none" : "blur(10px)",  // Apply blur initially
//             transition: "filter 0.3s ease-out",  // Smooth transition once image is loaded
//           }}
//         />
//       )}

//       {/* Content of the banner */}
//       <div className="container">
//         <div className="row align-items-center">
//           <div className="col-lg-7 col-md-12">
//             <div className="banner-content">
//               {banner?.vHeading && <span className="small-title">{banner.vHeading}</span>}

//               {banner?.vSubHeading && (
//                 <h1 className="banner-title">
//                   <span>{[firstTwoWords, rest[0]].filter(Boolean).join(" ")}</span> {rest.slice(1).join(" ")}
//                 </h1>
//               )}

//               {banner?.tDescription && <p>{banner.tDescription}</p>}

//               <button
//                 className="success-orangebtn"
//                 type="button"
//                 onClick={handleBookNowClick}
//               >
//                 Book Now
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default HomeBanner;

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getHomeBannerDetailList } from "../../store/Slice/homeBannerDetailSlice";
import { useNavigate } from "react-router-dom";

const HomeBanner = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { homeBannerDetailData, loading } = useSelector(
    (state) => state.homeBannerDetailList
  );

  const [imageSrc, setImageSrc] = useState(null); // Start with null for lazy load
  const [isImageLoaded, setIsImageLoaded] = useState(false); // Track image load state

  // Fetch banner data only once, and avoid conditional hook calls
  useEffect(() => {
    if (!homeBannerDetailData && !loading) {
      dispatch(getHomeBannerDetailList());
    }
  }, [dispatch, homeBannerDetailData, loading]);

  const banners =
    homeBannerDetailData?.code === 200 && homeBannerDetailData?.data?.length
      ? homeBannerDetailData.data
      : [];

  const banner = banners[0];

  // Fallback image while the API is fetching data
  const handleBookNowClick = () => navigate("/book-now");



  // Always call hooks unconditionally, even if data is not yet available
  React.useEffect(() => {
    if (banner?.vWebpImage) {
      // Preload the high-res image
      const preloadLink = document.createElement("link");
      preloadLink.rel = "preload";
      preloadLink.as = "image";
      preloadLink.href = banner.vWebpImage;
      preloadLink.fetchPriority = "high";
      document.head.appendChild(preloadLink);

      // Set the real banner image source after preload
      setImageSrc(banner.vWebpImage);

      // Clean up preload link on unmount
      return () => {
        document.head.removeChild(preloadLink);
      };
    }
  }, [banner]);

    // Show loading skeleton or empty until data is ready
    if (!banner || loading) {
      return (
        <section
          className="ptb-100 home-bannersection"
          style={{
            minHeight: "576px",
            backgroundColor: "#f6f6f6",
          }}
        />
      );
    }

  // Smooth fade-in effect for loaded image
  const [firstTwoWords, ...rest] = banner?.vSubHeading?.split(" ") || [];

  return (
    <section
      className="ptb-100 home-bannersection"
      style={{ position: "relative", overflow: "hidden" }}
    >
      {/* Dynamically load banner image with async image handling */}
      {imageSrc && (
        <img
          src={imageSrc}
          alt="MopForce Banner"
          fetchPriority="high"
          decoding="async"
          loading="eager"
          onLoad={() => setIsImageLoaded(true)} // Image loaded callback
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: -1,
            filter: isImageLoaded ? "none" : "blur(10px)", // Apply blur initially
            transition: "filter 0.3s ease-out", // Smooth transition once image is loaded
          }}
        />
      )}

      {/* Content of the banner */}
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-7 col-md-12">
            <div className="banner-content">
              {banner?.vHeading && (
                <span className="small-title">{banner.vHeading}</span>
              )}

              {banner?.vSubHeading && (
                <h1 className="banner-title">
                  <span>
                    {[firstTwoWords, rest[0]].filter(Boolean).join(" ")}
                  </span>{" "}
                  {rest.slice(1).join(" ")}
                </h1>
              )}

              {banner?.tDescription && <p>{banner.tDescription}</p>}

              <button
              style={{marginTop:"20px"}}
                className="success-orangebtn"
                type="button"
                onClick={handleBookNowClick}
              >
                Book Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeBanner;
